import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useState, useEffect } from 'react';
import EcoSpace from 'eco-design/base/eco-space';

export default function TheComp() {
    const { t } = useLang('dp3.page_v2');
    const [video, setVideo] = useState<[string, string]>(['', '']);
    const [enter, setEnter] = useState<boolean>(false);
    const [textEnter, setTextEnter] = useState<boolean>(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setEnter(true);
                    }
                });
            });
            observer.observe(document.getElementById('dp3-K2')!);

            const scene = AniContainer.create({
                triggerElement: '#dp3-K6 .box',
                triggerHook: 1,
                offset: 0,
                duration: '100%',
                onEnter: () => setTextEnter(true),
                onLeave: () => setTextEnter(false),
            });

            return () => scene.destroy();
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined' && enter) {
            if (window.innerWidth >= 768) {
                setVideo([
                    'https://websiteoss.ecoflow.com/upload/video/1735870727821/stay_powered.mp4',
                    'https://websiteoss.ecoflow.com/upload/image/1735639018740/BackupPriority2-poster-h5.png',
                ]);
            } else {
                setVideo([
                    'https://websiteoss.ecoflow.com/upload/video/1735637190381/BackupPriority2-h5.mp4',
                    'https://websiteoss.ecoflow.com/upload/image/1735639018924/BackupPriority2-poster.jpeg',
                ]);
            }
        }
    }, [enter]);

    return (
        <>
            <EcoSpace />
            <section className={styles.section} id="dp3-K6">
                <div className="box">
                    {video[0] && video[1] && (
                        <video
                            className="box-video"
                            src={video[0]}
                            poster={video[1]}
                            autoPlay
                            loop
                            muted
                            playsInline
                            preload="auto"
                            width="100%"
                            height="100%"
                        />
                    )}
                </div>
                <div className={`info${textEnter ? ' enter' : ''}`}>
                    <p className="info-title">{t('K6_title')}</p>
                    <p className="info-desc">{t('K6_desc')}</p>
                </div>
            </section>
            <EcoSpace />
        </>
    );
}
